import { Modal } from 'antd';

import './index.scss';

const confirm = Modal.confirm;

Modal.confirm = (options) => confirm({
  closable: true,
  ...options,
  icon: null,
  title: (
    <span className="title-inner">
      {options.icon || <span className="ic ic-xiangqing" />}{options.title}
    </span>
  )
});

export default Modal;
